import { COUNTRY_TO_LANG, FALLBACK_LANGUAGE, SUPPORTED_CODES } from "./languages";

/**
 * Best-effort IP geolocation → preferred UI language.
 * Falls back to {@link FALLBACK_LANGUAGE} on any error / unmapped country.
 *
 * Cached per page-load (and we use it only when we don't have a language
 * from the URL or from localStorage, so a single request per first visit).
 */
let inflight: Promise<string> | null = null;

export function detectLanguageByIp(): Promise<string> {
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const ctrl = new AbortController();
      const timeout = setTimeout(() => ctrl.abort(), 2500);
      const res = await fetch("https://ipapi.co/json/", { signal: ctrl.signal });
      clearTimeout(timeout);
      if (!res.ok) return FALLBACK_LANGUAGE;
      const data = (await res.json()) as { country_code?: string };
      const code = data.country_code?.toUpperCase() ?? "";
      const lang = COUNTRY_TO_LANG[code] ?? FALLBACK_LANGUAGE;
      return SUPPORTED_CODES.includes(lang) ? lang : FALLBACK_LANGUAGE;
    } catch {
      return FALLBACK_LANGUAGE;
    }
  })();

  return inflight;
}
